module.exports = __webpack_public_path__ + "static/media/ios-redo.b012efa3.svg";